import { AttributeStringValue, AttributeValue } from 'models/snapshot'
import { resolveValueTypeToString } from './resolveValueType'

export const mapToAttributeStringValue = (attrValue: AttributeValue): AttributeStringValue => ({
    ...attrValue,
    value: resolveValueTypeToString(attrValue.value),
})
